import { Tab } from "@blueprintjs/core"
import React, { useState } from "react"
import { useFragment } from "react-relay"
import { graphql } from "relay-runtime"

import styles from "./ProjectSidePanel.module.css"

import { ProjectSidePanel_project$key } from "./__generated__/ProjectSidePanel_project.graphql"
import { ProjectSidePanel_user$key } from "./__generated__/ProjectSidePanel_user.graphql"

import { ModalBody } from "../common/ModalForm"
import SidePanelHeader from "../common/SidePanel/SidePanelHeader"
import Tabs from "../common/Tabs"

import ProjectSidePanelNotes from "./ProjectSidePanelNotes"

type TabType = "notes"

type Props = {
  project: ProjectSidePanel_project$key
  user: ProjectSidePanel_user$key
  initialTab?: TabType
  focusedNoteId?: number
}

const ProjectSidePanel = ({ initialTab, focusedNoteId, ...props }: Props) => {
  const user = useFragment(
    graphql`
      fragment ProjectSidePanel_user on users {
        id
        ...ProjectSidePanelNotes_user
      }
    `,
    props.user,
  )

  const project = useFragment(
    graphql`
      fragment ProjectSidePanel_project on projects {
        id
        name
        emoji
        client {
          image_key
          website
          name
        }
        notes_aggregate {
          aggregate {
            count
          }
        }
        ...ProjectSidePanelNotes_project
      }
    `,
    props.project,
  )

  const [activeTab, setActiveTab] = useState(initialTab)

  const notesCount = project.notes_aggregate?.aggregate.count

  return (
    <section className={styles.container} data-test="project-side-panel">
      <SidePanelHeader
        title={project.name}
        type={{ kind: "project", project, client: project.client }}
        subtitle={project.client.name}
      />
      <ModalBody wide className={styles.tabContainer}>
        <Tabs
          large
          id="projectTabs"
          onChange={(tab: TabType) => {
            setActiveTab(tab)
          }}
          selectedTabId={activeTab}
          className={styles.projectTabs}
        >
          <Tab
            id="notes"
            title={notesCount ? `Notes (${notesCount})` : "Notes"}
            panel={
              <ProjectSidePanelNotes
                project={project}
                user={user}
                focusedNoteId={focusedNoteId}
              />
            }
          />
          <></>
        </Tabs>
      </ModalBody>
    </section>
  )
}

export default ProjectSidePanel
